/* eslint-disable prettier/prettier */
import { FormProps } from "antd";

export const formConfig: FormProps = {
  layout: "vertical",
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
}
